import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  ref: "textWrapperElement",
  class: "-mt-10 pb-10"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createElementVNode("div", {
      class: "my-10",
      innerHTML: _ctx.firstParagraph
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "overflow-hidden duration-200 transition-height ease-in-out",
      style: _normalizeStyle('height:' + _ctx.expandedHeight + 'px')
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allExceptFirstParagraph, (text) => {
          return (_openBlock(), _createElementBlock("div", {
            key: text,
            class: "o-anim-fade-1000-enter-active mt-10",
            innerHTML: text
          }, null, 8, _hoisted_3))
        }), 128))
      ], 512)
    ], 4),
    _createElementVNode("div", {
      class: "inline-flex items-center cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShowReadMoreSection && _ctx.toggleShowReadMoreSection(...args)))
    }, [
      _createVNode(_component_c_icon, {
        class: _normalizeClass([_ctx.showReadMoreSection ? 'rotate-45' : '', "transition duration-200"]),
        name: "icon-plus-small",
        height: "12"
      }, null, 8, ["class"]),
      (!_ctx.showReadMoreSection)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$dictionary.get('global/generic/readMore')), 1))
        : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$dictionary.get('global/generic/readLess')), 1))
    ])
  ]))
}